import MessageBox from './messageBox'

export default {
    install: function(Vue) {
        Vue.component('MessageBox', MessageBox)
    }
}